/*آموزش*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={93.04}
      height={93.04}
      viewBox="0 0 93.04 93.04"
      {...props}
    >
      <g data-name="Group 368" transform="translate(1.551 1.551)">
        <path
          data-name="Rectangle 692"
          fill="#00838f"
          d="M6.203 3.101h77.533v46.52H6.203z"
        />
        <path
          data-name="Rectangle 693"
          fill="#00bcd4"
          d="M6.203 3.101h72.881v46.52H6.203z"
        />
        <circle
          data-name="Ellipse 365"
          cx={6.203}
          cy={6.203}
          transform="translate(38.767 58.925)"
          fill="#cfd8dc"
          r={6.203}
        />
        <path
          data-name="Path 7666"
          d="M35.665 88.387v-8.2a9.315 9.315 0 0118.608 0v8.2z"
          fill="#e91e63"
        />
        <circle
          data-name="Ellipse 366"
          cx={6.203}
          cy={6.203}
          transform="translate(68.229 58.925)"
          fill="#cfd8dc"
          r={6.203}
        />
        <path
          data-name="Path 7667"
          d="M65.128 88.387v-8.2a9.315 9.315 0 0118.608 0v8.2z"
          fill="#ff9801"
        />
        <circle
          data-name="Ellipse 367"
          cx={6.203}
          cy={6.203}
          transform="translate(9.304 58.925)"
          fill="#cfd8dc"
          r={6.203}
        />
        <path
          data-name="Path 7668"
          d="M6.203 88.387v-8.2a9.315 9.315 0 0118.608 0v8.2z"
          fill="#009688"
        />
        <g data-name="Group 366" fill="#607d8b">
          <path
            data-name="Path 7669"
            d="M3.101 0h83.736a3.1 3.1 0 013.1 3.1 3.1 3.1 0 01-3.1 3.1H3.101a3.1 3.1 0 01-3.1-3.1 3.1 3.1 0 013.1-3.1z"
          />
          <path
            data-name="Path 7670"
            d="M3.101 46.52h83.736a3.1 3.1 0 013.1 3.1 3.1 3.1 0 01-3.1 3.1H3.101a3.1 3.1 0 01-3.1-3.1 3.1 3.1 0 013.1-3.1z"
          />
        </g>
        <g data-name="Group 367" fill="#cfd8dc">
          <path
            data-name="Path 7671"
            d="M3.021 0h79.246a3.021 3.021 0 013.021 3.021v.161a3.021 3.021 0 01-3.021 3.021H3.021A3.021 3.021 0 010 3.182v-.161A3.021 3.021 0 013.021 0z"
          />
          <path
            data-name="Path 7672"
            d="M3.021 46.52h79.246a3.021 3.021 0 013.021 3.021v.161a3.021 3.021 0 01-3.021 3.021H3.021A3.021 3.021 0 010 49.702v-.161a3.021 3.021 0 013.021-3.021z"
          />
        </g>
        <path
          data-name="Path 7673"
          d="M57.375 25.818v10.281l-7.707 3.272a11.123 11.123 0 01-2.869.791l5.923-2.512v-9.862z"
          fill="#f57c00"
        />
        <path
          data-name="Path 7674"
          d="M52.723 27.788v9.862L46.8 40.162a12.1 12.1 0 01-6.528-.791l-7.707-3.272v-10.28l10.079 4.28 1.969.837a.822.822 0 00.713 0z"
          fill="#ff9801"
        />
        <path
          data-name="Path 7675"
          d="M64.461 22.81l-4.667 1.985-2.419 1.028-12.049 5.117a.822.822 0 01-.713 0l-12.049-5.117-7.086-3.008a1.255 1.255 0 01-.233-2.047.865.865 0 01.233-.155l19.131-8.13a.821.821 0 01.713 0l19.135 8.126a1.246 1.246 0 010 2.2z"
          fill="#f57c00"
        />
        <path
          data-name="Path 7676"
          d="M59.794 24.795l-2.419 1.023-12.049 5.117a.822.822 0 01-.713 0l-12.049-5.117-7.086-3.008a1.255 1.255 0 01-.233-2.047l14.464-6.14a.822.822 0 01.713 0l19.135 8.126a1.255 1.255 0 01.233 2.047z"
          fill="#ff9801"
        />
        <path
          data-name="Path 7677"
          d="M1.551 83.736h86.837a1.551 1.551 0 011.551 1.551v3.1a1.551 1.551 0 01-1.551 1.551H1.551A1.551 1.551 0 010 88.387v-3.1a1.551 1.551 0 011.551-1.551z"
          fill="#607d8b"
        />
        <path
          data-name="Path 7678"
          d="M1.51 83.736h82.266a1.51 1.51 0 011.51 1.51v3.182a1.51 1.51 0 01-1.51 1.51H1.51A1.51 1.51 0 010 88.428v-3.182a1.51 1.51 0 011.51-1.51z"
          fill="#cfd8dc"
        />
      </g>
      <g data-name="Group 369">
        <path
          data-name="Path 7679"
          d="M88.388 9.3a4.652 4.652 0 100-9.3H4.652a4.652 4.652 0 100 9.3H6.2v37.22H4.652a4.652 4.652 0 100 9.3h83.736a4.652 4.652 0 100-9.3h-1.551V9.3zM3.1 4.652A1.553 1.553 0 014.652 3.1h83.736a1.551 1.551 0 010 3.1H4.652A1.553 1.553 0 013.1 4.652zm86.837 46.52a1.553 1.553 0 01-1.551 1.551H4.652a1.551 1.551 0 110-3.1h83.736a1.553 1.553 0 011.55 1.549zm-6.2-4.652H9.3V9.3h74.436v37.22z"
        />
        <path
          data-name="Path 7680"
          d="M26.361 35.562a1.551 1.551 0 001.551-1.551V26.42l4.652 1.977v9.27a1.547 1.547 0 00.116.574q.16.251.328.5a1.549 1.549 0 00.5.343l7.711 3.274a13.648 13.648 0 0010.6 0l7.7-3.27a1.551 1.551 0 00.5-.343q.168-.245.328-.5a1.548 1.548 0 00.116-.574V28.396l6.141-2.61a2.786 2.786 0 000-5.053l-19.125-8.131a2.444 2.444 0 00-1.925 0l-19.132 8.131a2.714 2.714 0 00-1.612 2.527v10.751a1.551 1.551 0 001.551 1.551zm31.018 1.062l-6.754 2.868a10.563 10.563 0 01-8.193 0l-6.762-2.871v-6.907l9.892 4.2a2.444 2.444 0 001.925 0l9.891-4.2v6.909zM46.52 15.563l18.113 7.7-6.3 2.679-.014.006-11.8 5.013-11.8-5.013-.014-.006-6.3-2.679z"
        />
        <path
          data-name="Path 7681"
          d="M89.938 83.736h-3.1v-1.994a10.373 10.373 0 00-5.821-9.216 7.753 7.753 0 10-10.068 0 10.374 10.374 0 00-5.821 9.216v1.994h-7.754v-1.994a10.373 10.373 0 00-5.821-9.216 7.753 7.753 0 10-10.068 0 10.374 10.374 0 00-5.821 9.216v1.994h-7.752v-1.994a10.373 10.373 0 00-5.821-9.216 7.753 7.753 0 10-10.068 0A10.374 10.374 0 006.2 81.742v1.994H3.1a3.1 3.1 0 00-3.1 3.1v3.1a3.1 3.1 0 003.1 3.1h86.838a3.1 3.1 0 003.1-3.1v-3.1a3.1 3.1 0 00-3.1-3.1zM71.33 66.681a4.652 4.652 0 114.652 4.652 4.652 4.652 0 01-4.652-4.652zm-3.1 15.064a7.767 7.767 0 0115.507 0v1.994H68.229v-1.994zM41.868 66.681a4.652 4.652 0 114.652 4.652 4.652 4.652 0 01-4.652-4.652zm-3.1 15.064a7.767 7.767 0 0115.507 0v1.994H38.767v-1.994zM12.405 66.681a4.652 4.652 0 114.652 4.652 4.652 4.652 0 01-4.652-4.652zM9.3 81.742a7.55 7.55 0 017.753-7.31 7.55 7.55 0 017.753 7.31v1.994H9.3zm-6.2 8.2v-3.1h86.838v3.1z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
